import React from "react";
import { useHistory } from "react-router-dom";
import Table from "components/admin/Table";
import useTeamParticipantsForCompetition from "hooks/teams/useTeamParticipantsForCompetition";

function TeamParticipantsReport({ competitionId }) {
  const { data: teams, isLoading } = useTeamParticipantsForCompetition(
    competitionId
  );
  const history = useHistory();
  const tableData = {
    defaultSort: "teamName",
    searchableColumns: ["teamName"],
    headingData: {
      teamName: "Name",
      count: "Count",
      isFullyPaid: "Is Paid",
      total: "Total Cost",
    },
    items: teams || [],
    childTableData: {
      defaultSort: "name",
      searchableColumns: ["name"],
      headingData: {
        id: "ID",
        name: "Name",
        paid: "Is Paid",
        total: "Total Cost",
      },
      itemsKey: "participants",
      itemClick,
    },
  };

  function itemClick({ id }) {
    history.push(`/adm/home/participant/${id}`);
  }

  return (
    <div className="TeamParticipantsReport">
      <h3>Team Athletes Report</h3>
      {isLoading ? (
        <div className="spinner-border mt-2" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      ) : (
        <Table data={tableData} />
      )}
    </div>
  );
}

export default TeamParticipantsReport;
